import { useFormik } from "formik";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { loginValidationSchema } from "./login.schema";
import AlertMessage from "../../../../Components/AlertMessage/AlertMessage";
import Loader from "../../../../Components/Loader/Loader";
import { getClientConfig } from "../../../../config/clientConfig";
import { LoginService } from "../../../../Services/AuthenticationService/AuthenticationService";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  setLoginState,
  setToken,
  setUserType,
} from "../../../../Reducer/AuthReducer";
import { useDispatch } from "react-redux";
import "./Login.css";
import logoImg from "../../../../Assets/Icons/IY VAULT icon-ios.png";
import PasswordInput from "../../../../Components/CommonUI/Input/Password";

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientConfig = getClientConfig();
  const [loading, setloading] = useState(false);
  const initialValues = {
    email: "",
    password: "",
    rememberMe: false,
  };
  const SubmitBtnClick = async (e: any) => {
    setloading(true);
    console.log(formik.values);
    try {
      const response = await LoginService(
        formik.values.email,
        formik.values.password
      );
      if (!response.success) {
        AlertMessage({
          type: "error",
          text: "Login failed. Please check your credentials.",
        });
        setloading(false);
        return;
      }
      if (response.success && response.user) {
        const { user } = response;

        dispatch(setLoginState({ status: true }));
        dispatch(setToken(user.jwt));
        dispatch(setUserType({ userType: user.roleId }));
        navigate("/");
      }

      setloading(false);
    } catch (error) {
      console.error("Login Error: \n ", error);
      setloading(false);
      return;
    }
  };

  const ForgotPsswordBtnClick = (e: any) => {
    e.preventDefault();
    console.log("Forgot Password Clicked");
    formik.values.email
      ? navigate(`/password-reset/${formik.values.email}`)
      : navigate(`/password-reset/`);
  };
  const RegisterBtnClick = (e: any) => {
    e.preventDefault();
    console.log("Forgot Password Clicked");
    formik.values.email
      ? navigate(`/register/${formik.values.email}`)
      : navigate(`/register/`);
  };

  const formik = useFormik({
    initialValues: initialValues || {},
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: SubmitBtnClick,
    validationSchema: loginValidationSchema,
  });

  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword(!showPassword);

  return (
    <div className="login">
      <div className="login-container">
        <div className="login-logo">
          <img src={clientConfig.logo_format_1 || logoImg} alt="Logo" />
        </div>
        <form className="loginForm" onSubmit={(e) => formik.handleSubmit(e)}>
          {/* Email */}
          <div className="form-row-horizontal">
            <label>
              Email <span>*</span>
            </label>
            <div className="input-field">
              <input
                // type="email"
                name="email"
                placeholder="name@example.com"
                value={formik.values.email}
                onChange={formik.handleChange}

                // onBlur={formik.handleBlur}
                className={
                  formik.errors.email && formik.touched.email
                    ? "input-error"
                    : ""
                }
              />
              <div className="error-holder">
                {formik.touched.email && formik.errors.email && (

                  <p className="error-text">{formik.errors.email}</p>
                )}
              </div>
            </div>
          </div>

          <div className="form-row-horizontal">
            <label>
              Password <span>*</span>
            </label>
            <div className="input-field password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="ex. abc123"
                value={formik.values.password}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                className={
                  formik.errors.password && formik.touched.password
                    ? "input-error"
                    : ""
                }
              />

              <span className="toggle-eye" onClick={togglePassword}>
                {showPassword ? <GoEye /> : <GoEyeClosed />}
              </span>

              <div className="error-holder">

                {formik.touched.password && formik.errors.password && (

                  <p className="error-text">{formik.errors.password}</p>
                )}
              </div>
            </div>
          </div>

          <div className="remember-row">
            <input
              name="rememberMe"
              type="checkbox"
              checked={formik.values.rememberMe}
              onChange={(e) =>
                formik.setFieldValue("rememberMe", e.target.checked)
              }
            />
            <label>Remember Me</label>
          </div>


          <button className="submit-btn" disabled={loading}>

            Login
          </button>
        </form>
        <div className="login-footer">
          <button onClick={ForgotPsswordBtnClick}>Forgot Password?</button>
          <button onClick={RegisterBtnClick}>Register</button>
        </div>
      </div>
    </div>
  );
};
